module.exports = __webpack_public_path__ + "img/AI.72fe501f.png";